// モーダル(contactセクション＞電話)
// =============================
(() => {
  if (typeof HTMLDialogElement === "undefined") return;
  let lastActiveElement = null;
  let scrollY = 0;

  const lockScroll = () => {
    scrollY = window.scrollY || document.documentElement.scrollTop;
    document.documentElement.classList.add("is-scroll-locked");
    document.body.classList.add("is-scroll-locked");
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  };

  const unlockScroll = () => {
    document.documentElement.classList.remove("is-scroll-locked");
    document.body.classList.remove("is-scroll-locked");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, scrollY);
  };

  // 開く
  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest(".js-modal-open");
    if (!openBtn) return;

    const section = openBtn.closest(".shopify-section");
    if (!section) return;

    const modal = section.querySelector("dialog.c-modal");
    if (!modal) return;

    lastActiveElement = openBtn;

    if (!modal.open) {
      lockScroll();
      modal.showModal();
    }
  });

  // 閉じる（×ボタン）
  document.addEventListener("click", (e) => {
    const closeBtn = e.target.closest(".js-modal-close");
    if (!closeBtn) return;

    const modal = closeBtn.closest("dialog.c-modal");
    if (modal?.open) modal.close();

    e.stopPropagation();
  });

  // 背景クリックで閉じる（panel外）
  document.addEventListener("click", (e) => {
    const modal =
      e.target instanceof Element ? e.target.closest("dialog.c-modal") : null;
    if (!modal || !modal.open) return;

    const panel = modal.querySelector(".c-modal__panel");
    if (!panel) return;

    const rect = panel.getBoundingClientRect();
    const clickedInsidePanel =
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom;

    if (!clickedInsidePanel) modal.close();
  });

  // 閉じたらフォーカス戻し + スクロール解除
  document.addEventListener(
    "close",
    (e) => {
      const modal = e.target;
      if (!(modal instanceof HTMLDialogElement)) return;

      unlockScroll();
      lastActiveElement?.focus?.();
      lastActiveElement = null;
    },
    true,
  );
})();

// アコーディオン
// =============================
